<template>
  <div class="set-sku">
    <div class="breadcrumb" style="background: #fff">添加SKU</div>
    <div class="third-title">基础设置</div>
  </div>
</template>
 <script>
export default {
  name: 'set-sku'
}
</script>
 <style scoped>
</style>
